<div>
    @if (allEntityTypes?.length) {
        <h5>{{ allEntityTypes?.length > 1 ? 'Materieel' : allEntityTypes[0].plural_name }}</h5>
    }
</div>

<table
    class="table table-hover table-center"
    [class.table-add-row]="!fieldFormData.form.disabled"
    [class.table-last-col]="!fieldFormData.form.disabled">
    <tr>
        @if (allEntityTypes?.length > 1) {
            <th class="icon-col"></th>
        }
        @for (field of tableHeader; track $index) {
            <th>
                {{ field.name }}
            </th>
        }
        @if (!fieldFormData.form.disabled) {
            <th></th>
        }
    </tr>

    @for (pheField of pheFields; track pheField.form.value) {
        <tr>
            @if (allEntityTypes?.length > 1) {
                <td class="icon-col">
                    <mat-icon [fontSet]="'fas'" [fontIcon]="getEntityTypeIcon(pheField)"></mat-icon>
                </td>
            }
            @for (field of pheField | orderTableFields; track $index) {
                <td class="table-input-{{ field.type }}">
                    <app-field-input [tableStyle]="true" [field]="field" [formData]="fieldFormData" />
                </td>
            }
            @if (!pheField.form.disabled) {
                <td>
                    <button
                        class="icon-button-medium"
                        (click)="removePhe(pheField)"
                        color="warn"
                        mat-icon-button
                        matTooltip="Verwijder"
                        matTooltipClass="warn-background"
                        matTooltipPosition="right"
                        tabindex="-1">
                        <mat-icon fontSet="fas" fontIcon="fa-trash"></mat-icon>
                    </button>
                </td>
            }
        </tr>
    }

    @if (Features.PlanningSaveSave | hasFeature) {
        @if (!fieldFormData.form.disabled) {
            <tr>
                <td [colSpan]="tableHeader?.length + (allEntityTypes?.length > 1 ? 1 : 0)">
                    <button class="w-100" (click)="openAddModal()" mat-button color="primary">
                        Toevoegen <i class="fas fa-plus"></i>
                    </button>
                </td>
            </tr>
        }
    }
</table>

<!-- Template for entity selection dialog -->
<ng-template #entitySelectionDialog>
    <h2 mat-dialog-title>Selecteer materieel</h2>

    <mat-dialog-content>
        <mat-form-field class="w-100 mt-3" appearance="outline">
            <mat-label class="mt-1">Zoeken</mat-label>
            <input
                [(ngModel)]="searchQuery"
                (ngModelChange)="filterEntities()"
                matInput
                placeholder="Zoek op naam"
                autofocus />
            <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>

        <mat-selection-list class="entity-list" [multiple]="false" [hideSingleSelectionIndicator]="true">
            @for (entity of filteredEntities; track entity.id) {
                <mat-list-option (click)="selectEntity(entity)">
                    <mat-icon
                        [fontSet]="'fas'"
                        [fontIcon]="entity.entitytypes[0]?.icon"
                        matListItemIcon
                        inline="true"></mat-icon>
                    <span matListItemTitle>{{ entity.name }}</span>
                </mat-list-option>
            }
        </mat-selection-list>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close>Annuleren</button>
    </mat-dialog-actions>
</ng-template>
